import { lazy, Suspense } from "react";

import { MapRouteLoader } from "components/map/RouteLoader";

const MapLazy = lazy(() => import("components/map/Map"));

export const SystemOverviewSatelliteMap = () => {
  return (
    <Suspense fallback={<MapRouteLoader />}>
      <MapLazy basemapId="satellite" />
    </Suspense>
  );
};

export default SystemOverviewSatelliteMap;
